import type { SVGProps } from 'react'

export const Emails = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="80"
    viewBox="0 0 81 80"
    width="81"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <foreignObject height="90" width="92" x="-5.5" y="-4.00002">
      <div
        style={{
          backdropFilter: 'blur(3px)',
          clipPath: 'url(#bgblur_0_2823_11090_clip_path)',
          height: '100%',
          width: '100%'
        }}
      ></div>
    </foreignObject>
    <g data-figma-bg-blur-radius="6">
      <mask fill="white" id="path-1-inside-1_2823_11090">
        <path d="M0.5 34C0.5 31.4819 1.68555 29.1108 3.7 27.6L35.7 3.59998C38.5444 1.46665 42.4556 1.46665 45.3 3.59998L77.3 27.6C79.3144 29.1108 80.5 31.4819 80.5 34V72C80.5 76.4183 76.9183 80 72.5 80H8.5C4.08172 80 0.5 76.4183 0.5 72V34Z" />
      </mask>
      <path
        d="M0.5 34C0.5 31.4819 1.68555 29.1108 3.7 27.6L35.7 3.59998C38.5444 1.46665 42.4556 1.46665 45.3 3.59998L77.3 27.6C79.3144 29.1108 80.5 31.4819 80.5 34V72C80.5 76.4183 76.9183 80 72.5 80H8.5C4.08172 80 0.5 76.4183 0.5 72V34Z"
        fill="url(#paint0_linear_2823_11090)"
        fillOpacity="0.4"
      />
      <g
        clipPath="url(#paint1_angular_2823_11090_clip_path)"
        data-figma-skip-parse="true"
        mask="url(#path-1-inside-1_2823_11090)"
      >
        <g transform="matrix(5.50604e-10 0.04 -0.04 6.42151e-09 40.5 40)">
          <foreignObject height="2025" width="2025" x="-1012.5" y="-1012.5">
            <div
              style={{
                background:
                  'conic-gradient(from 90deg,rgba(255, 255, 255, 0.5692) 0deg,rgba(255, 255, 255, 0.8) 34.616deg,rgba(255, 255, 255, 0.2) 72.6934deg,rgba(255, 255, 255, 0.8) 124.617deg,rgba(255, 255, 255, 0.2) 304.62deg,rgba(255, 255, 255, 0.5692) 360deg)',
                height: '100%',
                width: '100%',
                opacity: 1
              }}
            ></div>
          </foreignObject>
        </g>
      </g>
      <path
        d="M45.3 3.59998L45 3.99998L45.3 3.59998ZM77.3 27.6L77.6 27.2L77.3 27.6ZM80.5 34H80V72H80.5H81V34H80.5ZM72.5 80V79.5H8.5V80V80.5H72.5V80ZM0.5 72H1V34H0.5H0V72H0.5ZM3.7 27.6L4 28L36 3.99998L35.7 3.59998L35.4 3.19998L3.4 27.2L3.7 27.6ZM45.3 3.59998L45 3.99998L77 28L77.3 27.6L77.6 27.2L45.6 3.19998L45.3 3.59998ZM35.7 3.59998L36 3.99998C38.6667 1.99998 42.3333 1.99998 45 3.99998L45.3 3.59998L45.6 3.19998C42.5778 0.933318 38.4222 0.933318 35.4 3.19998L35.7 3.59998ZM8.5 80V79.5C4.35787 79.5 1 76.1421 1 72H0.5H0C0 76.6944 3.80558 80.5 8.5 80.5V80ZM80.5 72H80C80 76.1421 76.6421 79.5 72.5 79.5V80V80.5C77.1944 80.5 81 76.6944 81 72H80.5ZM80.5 34H81C81 31.3245 79.7403 28.8052 77.6 27.2L77.3 27.6L77 28C78.8885 29.4164 80 31.6393 80 34H80.5ZM0.5 34H1C1 31.6393 2.11146 29.4164 4 28L3.7 27.6L3.4 27.2C1.25965 28.8052 0 31.3245 0 34H0.5Z"
        data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_ANGULAR&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.096155457198619843},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.20192614197731018},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.34615889191627502},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.84616577625274658}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.096155457198619843},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.20192614197731018},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.34615889191627502},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.84616577625274658}],&#34;transform&#34;:{&#34;m00&#34;:1.1012082268280210e-06,&#34;m01&#34;:-80.000015258789062,&#34;m02&#34;:80.500007629394531,&#34;m10&#34;:80.0,&#34;m11&#34;:1.2843016520491801e-05,&#34;m12&#34;:-2.6448667995282449e-05},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
        mask="url(#path-1-inside-1_2823_11090)"
      />
    </g>
    <rect
      fill="url(#paint2_linear_2823_11090)"
      height="60"
      rx="8"
      width="60"
      x="10.5"
      y="10"
    />
    <rect
      fill="url(#paint3_linear_2823_11090)"
      height="6"
      rx="3"
      width="32"
      x="20.5"
      y="55"
    />
    <rect
      fill="url(#paint4_linear_2823_11090)"
      height="6"
      rx="3"
      width="32"
      x="20.5"
      y="43"
    />
    <rect
      fill="url(#paint5_linear_2823_11090)"
      height="6"
      rx="3"
      width="40"
      x="20.5"
      y="19"
    />
    <rect
      fill="url(#paint6_linear_2823_11090)"
      height="6"
      rx="3"
      width="40"
      x="20.5"
      y="31"
    />
    <foreignObject height="66.1348" width="96" x="-7.5" y="21.8652">
      <div
        style={{
          backdropFilter: 'blur(4px)',
          clipPath: 'url(#bgblur_1_2823_11090_clip_path)',
          height: '100%',
          width: '100%'
        }}
      ></div>
    </foreignObject>
    <g data-figma-bg-blur-radius="8">
      <mask fill="white" id="path-8-inside-2_2823_11090">
        <path d="M79.3447 29.8652C80.089 31.0974 80.5 32.5226 80.5 34V72C80.5 76.4183 76.9183 80 72.5 80H8.5C4.08173 80 0.500016 76.4183 0.5 72V34C0.5 32.5227 0.910218 31.0973 1.6543 29.8652L35.7002 55.4004C38.5445 57.5334 42.4555 57.5334 45.2998 55.4004L79.3447 29.8652Z" />
      </mask>
      <path
        d="M79.3447 29.8652C80.089 31.0974 80.5 32.5226 80.5 34V72C80.5 76.4183 76.9183 80 72.5 80H8.5C4.08173 80 0.500016 76.4183 0.5 72V34C0.5 32.5227 0.910218 31.0973 1.6543 29.8652L35.7002 55.4004C38.5445 57.5334 42.4555 57.5334 45.2998 55.4004L79.3447 29.8652Z"
        fill="url(#paint7_linear_2823_11090)"
        fillOpacity="0.4"
      />
      <g
        clipPath="url(#paint8_angular_2823_11090_clip_path)"
        data-figma-skip-parse="true"
        mask="url(#path-8-inside-2_2823_11090)"
      >
        <g transform="matrix(5.50604e-10 0.0250674 -0.04 4.02426e-09 40.5 54.9326)">
          <foreignObject
            height="2039.89"
            width="2039.89"
            x="-1019.95"
            y="-1019.95"
          >
            <div
              style={{
                background:
                  'conic-gradient(from 90deg,rgba(255, 255, 255, 0.5692) 0deg,rgba(255, 255, 255, 0.2) 55.3803deg,rgba(255, 255, 255, 0.8) 235.383deg,rgba(255, 255, 255, 0.2) 287.307deg,rgba(255, 255, 255, 0.8) 325.384deg,rgba(255, 255, 255, 0.5692) 360deg)',
                height: '100%',
                width: '100%',
                opacity: 1
              }}
            ></div>
          </foreignObject>
        </g>
      </g>
      <path
        d="M79.3447 29.8652L79.7727 29.6067L79.4869 29.1336L79.0447 29.4653L79.3447 29.8652ZM80.5 72H81H80.5ZM8.5 80V80.5V80ZM0.5 72H0H0.5ZM1.6543 29.8652L1.9543 29.4653L1.51207 29.1336L1.22629 29.6068L1.6543 29.8652ZM35.7002 55.4004L35.4002 55.8004L35.4002 55.8004L35.7002 55.4004ZM45.2998 55.4004L45.5998 55.8004L45.5998 55.8004L45.2998 55.4004ZM79.3447 29.8652L78.9167 30.1238C79.6149 31.2797 80 32.6157 80 34H80.5H81C81 32.4294 80.563 30.9152 79.7727 29.6067L79.3447 29.8652ZM80.5 34H80V72H80.5H81V34H80.5ZM80.5 72H80C80 76.1421 76.6421 79.5 72.5 79.5V80V80.5C77.1944 80.5 81 76.6944 81 72H80.5ZM72.5 80V79.5H8.5V80V80.5H72.5V80ZM8.5 80V79.5C4.35788 79.5 1.00002 76.1421 1 72H0.5H0C1.75238e-05 76.6944 3.80559 80.5 8.5 80.5V80ZM0.5 72H1V34H0.5H0V72H0.5ZM0.5 34H1C1 32.6157 1.38437 31.2794 2.0823 30.1237L1.6543 29.8652L1.22629 29.6068C0.436061 30.9153 0 32.4298 0 34H0.5ZM1.6543 29.8652L1.35429 30.2652L35.4002 55.8004L35.7002 55.4004L36.0002 55.0004L1.9543 29.4653L1.6543 29.8652ZM35.7002 55.4004L35.4002 55.8004C38.4223 58.0668 42.5777 58.0668 45.5998 55.8004L45.2998 55.4004L44.9998 55.0004C42.3333 57.0001 38.6667 57.0001 36.0002 55.0004L35.7002 55.4004ZM45.2998 55.4004L45.5998 55.8004L79.6447 30.2652L79.3447 29.8652L79.0447 29.4653L44.9998 55.0004L45.2998 55.4004Z"
        data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_ANGULAR&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.15383422374725342},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.65384113788604736},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.79807388782501221},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.90384453535079956}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.15383422374725342},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.65384113788604736},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.79807388782501221},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.90384453535079956}],&#34;transform&#34;:{&#34;m00&#34;:1.1012082268280210e-06,&#34;m01&#34;:-80.000015258789062,&#34;m02&#34;:80.500007629394531,&#34;m10&#34;:50.134769439697266,&#34;m11&#34;:8.0485206126468256e-06,&#34;m12&#34;:29.865242004394531},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
        mask="url(#path-8-inside-2_2823_11090)"
      />
    </g>
    <foreignObject height="46.0002" width="92.4824" x="-5.74121" y="41.9999">
      <div
        style={{
          backdropFilter: 'blur(4px)',
          clipPath: 'url(#bgblur_2_2823_11090_clip_path)',
          height: '100%',
          width: '100%'
        }}
      ></div>
    </foreignObject>
    <g data-figma-bg-blur-radius="8">
      <mask fill="white" id="path-10-inside-3_2823_11090">
        <path d="M35.7002 51.5998C38.5445 49.4667 42.4555 49.4667 45.2998 51.5998L77.2998 75.5998C77.8438 76.0078 78.3251 76.4807 78.7412 77.0002C77.275 78.8279 75.0254 80.0002 72.5 80.0002H8.5C5.97458 80.0002 3.72495 78.8279 2.25879 77.0002C2.67487 76.4807 3.15618 76.0078 3.7002 75.5998L35.7002 51.5998Z" />
      </mask>
      <path
        d="M35.7002 51.5998C38.5445 49.4667 42.4555 49.4667 45.2998 51.5998L77.2998 75.5998C77.8438 76.0078 78.3251 76.4807 78.7412 77.0002C77.275 78.8279 75.0254 80.0002 72.5 80.0002H8.5C5.97458 80.0002 3.72495 78.8279 2.25879 77.0002C2.67487 76.4807 3.15618 76.0078 3.7002 75.5998L35.7002 51.5998Z"
        fill="url(#paint9_linear_2823_11090)"
        fillOpacity="0.4"
      />
      <g
        clipPath="url(#paint10_angular_2823_11090_clip_path)"
        data-figma-skip-parse="true"
        mask="url(#path-10-inside-3_2823_11090)"
      >
        <g transform="matrix(5.26394e-10 0.0150001 -0.0382412 2.40808e-09 40.5 65.0003)">
          <foreignObject
            height="2066.67"
            width="2066.67"
            x="-1033.33"
            y="-1033.33"
          >
            <div
              style={{
                background:
                  'conic-gradient(from 90deg,rgba(255, 255, 255, 0.5692) 0deg,rgba(255, 255, 255, 0.8) 34.616deg,rgba(255, 255, 255, 0.2) 72.6934deg,rgba(255, 255, 255, 0.8) 124.617deg,rgba(255, 255, 255, 0.2) 304.62deg,rgba(255, 255, 255, 0.5692) 360deg)',
                height: '100%',
                width: '100%',
                opacity: 1
              }}
            ></div>
          </foreignObject>
        </g>
      </g>
      <path
        d="M35.7002 51.5998L35.4002 51.1998L35.4002 51.1998L35.7002 51.5998ZM45.2998 51.5998L45.5998 51.1998L45.5998 51.1998L45.2998 51.5998ZM77.2998 75.5998L77.5998 75.1998L77.2998 75.5998ZM78.7412 77.0002L79.1312 77.313L79.382 77.0004L79.1314 76.6876L78.7412 77.0002ZM8.5 80.0002V80.5002V80.0002ZM2.25879 77.0002L1.86855 76.6876L1.61797 77.0004L1.86877 77.313L2.25879 77.0002ZM3.7002 75.5998L4.0002 75.9998H4.0002L3.7002 75.5998ZM35.7002 51.5998L36.0002 51.9998C38.6668 50 42.3332 50 44.9998 51.9998L45.2998 51.5998L45.5998 51.1998C42.5777 48.9333 38.4223 48.9333 35.4002 51.1998L35.7002 51.5998ZM45.2998 51.5998L44.9998 51.9998L76.9998 75.9998L77.2998 75.5998L77.5998 75.1998L45.5998 51.1998L45.2998 51.5998ZM77.2998 75.5998L76.9998 75.9998C77.5086 76.3814 77.9599 76.8246 78.351 77.3127L78.7412 77.0002L79.1314 76.6876C78.6903 76.1369 78.179 75.6342 77.5998 75.1998L77.2998 75.5998ZM78.7412 77.0002L78.3512 76.6873C76.9755 78.4022 74.8669 79.5002 72.5 79.5002V80.0002V80.5002C75.1839 80.5002 77.5745 79.2536 79.1312 77.313L78.7412 77.0002ZM72.5 80.0002V79.5002H8.5V80.0002V80.5002H72.5V80.0002ZM8.5 80.0002V79.5002C6.1331 79.5002 4.02445 78.4022 2.64881 76.6873L2.25879 77.0002L1.86877 77.313C3.42545 79.2536 5.81607 80.5002 8.5 80.5002V80.0002ZM2.25879 77.0002L2.64903 77.3127C3.04007 76.8246 3.49137 76.3814 4.0002 75.9998L3.7002 75.5998L3.4002 75.1998C2.821 75.6342 2.30968 76.1369 1.86855 76.6876L2.25879 77.0002ZM3.7002 75.5998L4.0002 75.9998L36.0002 51.9998L35.7002 51.5998L35.4002 51.1998L3.4002 75.1998L3.7002 75.5998Z"
        data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_ANGULAR&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.096155457198619843},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.20192614197731018},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.34615889191627502},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.84616577625274658}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.096155457198619843},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.20192614197731018},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.34615889191627502},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.84616577625274658}],&#34;transform&#34;:{&#34;m00&#34;:1.0527884342081961e-06,&#34;m01&#34;:-76.482437133789062,&#34;m02&#34;:78.741218566894531,&#34;m10&#34;:30.000211715698242,&#34;m11&#34;:4.8161650738620665e-06,&#34;m12&#34;:50.000148773193359},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
        mask="url(#path-10-inside-3_2823_11090)"
      />
    </g>
    <defs>
      <clipPath
        id="bgblur_0_2823_11090_clip_path"
        transform="translate(5.5 4.00002)"
      >
        <path d="M0.5 34C0.5 31.4819 1.68555 29.1108 3.7 27.6L35.7 3.59998C38.5444 1.46665 42.4556 1.46665 45.3 3.59998L77.3 27.6C79.3144 29.1108 80.5 31.4819 80.5 34V72C80.5 76.4183 76.9183 80 72.5 80H8.5C4.08172 80 0.5 76.4183 0.5 72V34Z" />
      </clipPath>
      <clipPath id="paint1_angular_2823_11090_clip_path">
        <path
          d="M45.3 3.59998L45 3.99998L45.3 3.59998ZM77.3 27.6L77.6 27.2L77.3 27.6ZM80.5 34H80V72H80.5H81V34H80.5ZM72.5 80V79.5H8.5V80V80.5H72.5V80ZM0.5 72H1V34H0.5H0V72H0.5ZM3.7 27.6L4 28L36 3.99998L35.7 3.59998L35.4 3.19998L3.4 27.2L3.7 27.6ZM45.3 3.59998L45 3.99998L77 28L77.3 27.6L77.6 27.2L45.6 3.19998L45.3 3.59998ZM35.7 3.59998L36 3.99998C38.6667 1.99998 42.3333 1.99998 45 3.99998L45.3 3.59998L45.6 3.19998C42.5778 0.933318 38.4222 0.933318 35.4 3.19998L35.7 3.59998ZM8.5 80V79.5C4.35787 79.5 1 76.1421 1 72H0.5H0C0 76.6944 3.80558 80.5 8.5 80.5V80ZM80.5 72H80C80 76.1421 76.6421 79.5 72.5 79.5V80V80.5C77.1944 80.5 81 76.6944 81 72H80.5ZM80.5 34H81C81 31.3245 79.7403 28.8052 77.6 27.2L77.3 27.6L77 28C78.8885 29.4164 80 31.6393 80 34H80.5ZM0.5 34H1C1 31.6393 2.11146 29.4164 4 28L3.7 27.6L3.4 27.2C1.25965 28.8052 0 31.3245 0 34H0.5Z"
          mask="url(#path-1-inside-1_2823_11090)"
        />
      </clipPath>
      <clipPath
        id="bgblur_1_2823_11090_clip_path"
        transform="translate(7.5 -21.8652)"
      >
        <path d="M79.3447 29.8652C80.089 31.0974 80.5 32.5226 80.5 34V72C80.5 76.4183 76.9183 80 72.5 80H8.5C4.08173 80 0.500016 76.4183 0.5 72V34C0.5 32.5227 0.910218 31.0973 1.6543 29.8652L35.7002 55.4004C38.5445 57.5334 42.4555 57.5334 45.2998 55.4004L79.3447 29.8652Z" />
      </clipPath>
      <clipPath id="paint8_angular_2823_11090_clip_path">
        <path
          d="M79.3447 29.8652L79.7727 29.6067L79.4869 29.1336L79.0447 29.4653L79.3447 29.8652ZM80.5 72H81H80.5ZM8.5 80V80.5V80ZM0.5 72H0H0.5ZM1.6543 29.8652L1.9543 29.4653L1.51207 29.1336L1.22629 29.6068L1.6543 29.8652ZM35.7002 55.4004L35.4002 55.8004L35.4002 55.8004L35.7002 55.4004ZM45.2998 55.4004L45.5998 55.8004L45.5998 55.8004L45.2998 55.4004ZM79.3447 29.8652L78.9167 30.1238C79.6149 31.2797 80 32.6157 80 34H80.5H81C81 32.4294 80.563 30.9152 79.7727 29.6067L79.3447 29.8652ZM80.5 34H80V72H80.5H81V34H80.5ZM80.5 72H80C80 76.1421 76.6421 79.5 72.5 79.5V80V80.5C77.1944 80.5 81 76.6944 81 72H80.5ZM72.5 80V79.5H8.5V80V80.5H72.5V80ZM8.5 80V79.5C4.35788 79.5 1.00002 76.1421 1 72H0.5H0C1.75238e-05 76.6944 3.80559 80.5 8.5 80.5V80ZM0.5 72H1V34H0.5H0V72H0.5ZM0.5 34H1C1 32.6157 1.38437 31.2794 2.0823 30.1237L1.6543 29.8652L1.22629 29.6068C0.436061 30.9153 0 32.4298 0 34H0.5ZM1.6543 29.8652L1.35429 30.2652L35.4002 55.8004L35.7002 55.4004L36.0002 55.0004L1.9543 29.4653L1.6543 29.8652ZM35.7002 55.4004L35.4002 55.8004C38.4223 58.0668 42.5777 58.0668 45.5998 55.8004L45.2998 55.4004L44.9998 55.0004C42.3333 57.0001 38.6667 57.0001 36.0002 55.0004L35.7002 55.4004ZM45.2998 55.4004L45.5998 55.8004L79.6447 30.2652L79.3447 29.8652L79.0447 29.4653L44.9998 55.0004L45.2998 55.4004Z"
          mask="url(#path-8-inside-2_2823_11090)"
        />
      </clipPath>
      <clipPath
        id="bgblur_2_2823_11090_clip_path"
        transform="translate(5.74121 -41.9999)"
      >
        <path d="M35.7002 51.5998C38.5445 49.4667 42.4555 49.4667 45.2998 51.5998L77.2998 75.5998C77.8438 76.0078 78.3251 76.4807 78.7412 77.0002C77.275 78.8279 75.0254 80.0002 72.5 80.0002H8.5C5.97458 80.0002 3.72495 78.8279 2.25879 77.0002C2.67487 76.4807 3.15618 76.0078 3.7002 75.5998L35.7002 51.5998Z" />
      </clipPath>
      <clipPath id="paint10_angular_2823_11090_clip_path">
        <path
          d="M35.7002 51.5998L35.4002 51.1998L35.4002 51.1998L35.7002 51.5998ZM45.2998 51.5998L45.5998 51.1998L45.5998 51.1998L45.2998 51.5998ZM77.2998 75.5998L77.5998 75.1998L77.2998 75.5998ZM78.7412 77.0002L79.1312 77.313L79.382 77.0004L79.1314 76.6876L78.7412 77.0002ZM8.5 80.0002V80.5002V80.0002ZM2.25879 77.0002L1.86855 76.6876L1.61797 77.0004L1.86877 77.313L2.25879 77.0002ZM3.7002 75.5998L4.0002 75.9998H4.0002L3.7002 75.5998ZM35.7002 51.5998L36.0002 51.9998C38.6668 50 42.3332 50 44.9998 51.9998L45.2998 51.5998L45.5998 51.1998C42.5777 48.9333 38.4223 48.9333 35.4002 51.1998L35.7002 51.5998ZM45.2998 51.5998L44.9998 51.9998L76.9998 75.9998L77.2998 75.5998L77.5998 75.1998L45.5998 51.1998L45.2998 51.5998ZM77.2998 75.5998L76.9998 75.9998C77.5086 76.3814 77.9599 76.8246 78.351 77.3127L78.7412 77.0002L79.1314 76.6876C78.6903 76.1369 78.179 75.6342 77.5998 75.1998L77.2998 75.5998ZM78.7412 77.0002L78.3512 76.6873C76.9755 78.4022 74.8669 79.5002 72.5 79.5002V80.0002V80.5002C75.1839 80.5002 77.5745 79.2536 79.1312 77.313L78.7412 77.0002ZM72.5 80.0002V79.5002H8.5V80.0002V80.5002H72.5V80.0002ZM8.5 80.0002V79.5002C6.1331 79.5002 4.02445 78.4022 2.64881 76.6873L2.25879 77.0002L1.86877 77.313C3.42545 79.2536 5.81607 80.5002 8.5 80.5002V80.0002ZM2.25879 77.0002L2.64903 77.3127C3.04007 76.8246 3.49137 76.3814 4.0002 75.9998L3.7002 75.5998L3.4002 75.1998C2.821 75.6342 2.30968 76.1369 1.86855 76.6876L2.25879 77.0002ZM3.7002 75.5998L4.0002 75.9998L36.0002 51.9998L35.7002 51.5998L35.4002 51.1998L3.4002 75.1998L3.7002 75.5998Z"
          mask="url(#path-10-inside-3_2823_11090)"
        />
      </clipPath>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_2823_11090"
        x1="40.5"
        x2="40.5"
        y1="28"
        y2="80"
      >
        <stop stopColor="#77ACFF" />
        <stop offset="1" stopColor="#A8C8FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint2_linear_2823_11090"
        x1="40.5"
        x2="40.5"
        y1="10"
        y2="70"
      >
        <stop stopColor="#A8C8FF" />
        <stop offset="1" stopColor="#4691F4" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint3_linear_2823_11090"
        x1="41.8333"
        x2="20.5"
        y1="58"
        y2="58"
      >
        <stop stopColor="#A8C8FF" />
        <stop offset="1" stopColor="#77ACFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint4_linear_2823_11090"
        x1="41.8333"
        x2="20.5"
        y1="46"
        y2="46"
      >
        <stop stopColor="#A8C8FF" />
        <stop offset="1" stopColor="#77ACFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint5_linear_2823_11090"
        x1="47.1667"
        x2="20.5"
        y1="22"
        y2="22"
      >
        <stop stopColor="#A8C8FF" />
        <stop offset="1" stopColor="#77ACFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint6_linear_2823_11090"
        x1="47.1667"
        x2="20.5"
        y1="34"
        y2="34"
      >
        <stop stopColor="#A8C8FF" />
        <stop offset="1" stopColor="#77ACFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint7_linear_2823_11090"
        x1="40.5"
        x2="40.5"
        y1="51.3995"
        y2="80"
      >
        <stop stopColor="#77ACFF" />
        <stop offset="1" stopColor="#A8C8FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint9_linear_2823_11090"
        x1="40.5"
        x2="40.5"
        y1="62.886"
        y2="80.0004"
      >
        <stop stopColor="#77ACFF" />
        <stop offset="1" stopColor="#A8C8FF" />
      </linearGradient>
    </defs>
  </svg>
)
